package com.example.readingnotes.data.remote.mapper

import com.example.readingnotes.data.remote.dto.CommentDto
import com.example.readingnotes.domain.model.Comment
import kotlinx.datetime.Instant

fun CommentDto.toDomain(): Comment =
    Comment(
        id = id,
        postId = postId,
        tenantId = tenantId,
        authorName = authorName,
        content = content,
        createdAt = Instant.parse(createdAt),
    )

fun List<CommentDto>.toDomain(): List<Comment> = map { it.toDomain() }
